import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import verificationImg from "../../assets/Verification.png";
import "./addfinger.css";

const AddFingerprint = () => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const [employeeId, setEmployeeId] = useState("");
  const [step, setStep] = useState("enterId");

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [errorModal, setErrorModal] = useState({
    show: false,
    title: "",
    message: "",
    redirectHome: false,
  });
  const [scanMessage, setScanMessage] = useState("");

  /* -------------------- ERROR MODAL HANDLER -------------------- */
  const showError = (title, message, redirectHome = false) => {
    setErrorModal({ show: true, title, message, redirectHome });
  };

  const closeErrorModal = () => {
    const shouldRedirect = errorModal.redirectHome;
    setErrorModal({ show: false, title: "", message: "", redirectHome: false });
    if (shouldRedirect) {
      navigate("/");
    }
  };

  /* -------------------- FETCH EMPLOYEE DETAILS -------------------- */
  const handleSubmitId = async () => {
    if (!employeeId.trim()) {
      showError("Invalid Input", "Please enter Employee ID");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `https://mondelezbc.vsmglobaltechnologies.com/api/user/details/MON-${employeeId}`
      );
      const json = await res.json();

      if (!res.ok || !json.data) {
        throw new Error("Employee not found");
      }

      setProfile(json.data);
      setStep("showDetails");
    } catch (err) {
      showError(
        "Employee Not Found",
        `Employee with ID MON-${employeeId} could not be found in the system. Please verify the ID and try again.`,
        true
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => navigate("/");

  /* -------------------- FINGERPRINT FLOW -------------------- */
  const handleAddFingerprint = async () => {
    setStep("touchFinger");
    setScanMessage("⏳ Place your finger on the scanner...");
    setProcessing(true);

    const controller = new AbortController();
    timeoutRef.current = setTimeout(() => controller.abort(), 10000);

    try {
      /* 1️⃣ CAPTURE */
      const captureRes = await fetch(
        "http://localhost:8030/morfinauth/capture",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Quality: "60", TimeOut: "10" }),
          signal: controller.signal,
        }
      );

      clearTimeout(timeoutRef.current);
      const captureData = await captureRes.json();

      if (captureData.ErrorCode !== "0") {
        throw new Error("CAPTURE_FAILED");
      }

      setScanMessage("🔄 Extracting fingerprint template...");

      /* 2️⃣ GET TEMPLATE */
      const templateRes = await fetch(
        "http://localhost:8030/morfinauth/gettemplate",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ TmpFormat: 2 }),
        }
      );

      const templateData = await templateRes.json();

      if (templateData.ErrorCode !== "0" || !templateData.ImgData) {
        throw new Error("TEMPLATE_FAILED");
      }

      setScanMessage("💾 Saving fingerprint...");

      /* 3️⃣ SAVE FINGERPRINT */
      const saveRes = await fetch(
        "https://mondelezbc.vsmglobaltechnologies.com/api/user/add_fingerprint",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            employeeCode: `MON-${employeeId}`,
            fingerprint_ansi: templateData.ImgData,
          }),
        }
      );

      if (!saveRes.ok) {
        throw new Error("SAVE_FAILED");
      }

      setProcessing(false);
      setStep("result");
    } catch (err) {
      clearTimeout(timeoutRef.current);
      setProcessing(false);

      let errorTitle = "Fingerprint Error";
      let errorMessage =
        "An unexpected error occurred during fingerprint enrollment.";

      if (err.name === "AbortError") {
        errorTitle = "Scan Timeout";
        errorMessage =
          "The fingerprint scan timed out after 10 seconds. Please ensure your finger is properly placed on the scanner and try again.";
      } else if (err.message === "CAPTURE_FAILED") {
        errorTitle = "Capture Failed";
        errorMessage =
          "Failed to capture fingerprint. Please ensure the scanner is connected and your finger is clean and dry.";
      } else if (err.message === "TEMPLATE_FAILED") {
        errorTitle = "Template Extraction Failed";
        errorMessage =
          "Failed to extract fingerprint template. Please try scanning again with better finger placement.";
      } else if (err.message === "SAVE_FAILED") {
        errorTitle = "Save Failed";
        errorMessage =
          "Failed to save fingerprint to the database. Please check your connection and try again.";
      } else if (err.message.includes("fetch")) {
        errorTitle = "Connection Error";
        errorMessage =
          "Unable to connect to the fingerprint scanner. Please ensure the device is connected and the service is running.";
      }

      showError(errorTitle, errorMessage, true);
    }
  };

  return (
    <div className="fingerprint-container">
      <a className="home-icon" href="/">
        <svg
          fill="#fff"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          width="35px"
          height="35px"
          viewBox="0 0 495.398 495.398"
        >
          <g>
            <g>
              <g>
                <path
                  d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
				v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
				c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
				c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"
                />
                <path
                  d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
				c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
				c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"
                />
              </g>
            </g>
          </g>
        </svg>
      </a>
      {/* ERROR MODAL */}
      {errorModal.show && (
        <div className="modal-overlay" onClick={closeErrorModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-icon">⚠️</span>
              <h3>{errorModal.title}</h3>
            </div>
            <div className="modal-body">
              <p>{errorModal.message}</p>
            </div>
            <div className="modal-footer">
              <button onClick={closeErrorModal} className="modal-btn">
                {errorModal.redirectHome ? "Go to Home" : "Close"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* STEP 1 */}
      {step === "enterId" && (
        <div className="employee-id-box">
          <h2>Enter Employee ID</h2>
          <div className="employee-id-display">MON-{employeeId || "—"}</div>

          <div className="number-pad">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((n) => (
              <button
                key={n}
                className="number-key"
                onClick={() => setEmployeeId((p) => p + n)}
              >
                {n}
              </button>
            ))}
            <button
              className="number-key clear"
              onClick={() => setEmployeeId("")}
            >
              Clear
            </button>
            <button
              className="number-key delete"
              onClick={() => setEmployeeId((p) => p.slice(0, -1))}
            >
              ⌫
            </button>
          </div>

          {loading && (
            <p className="loading-text">Fetching employee details...</p>
          )}

          <div className="buttons-row">
            <button
              onClick={handleSubmitId}
              className="submit-btn"
              disabled={loading}
            >
              Submit
            </button>
            <button onClick={handleCancel} className="cancel-btn">
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* STEP 2 */}
      {step === "showDetails" && profile && (
        <div className="profile-box">
          <h2>Employee Details</h2>
          <p>
            <strong>Name:</strong> {profile.name}
          </p>
          <p>
            <strong>Employee ID:</strong> {profile.employeeCode}
          </p>
          <p>
            <strong>Designation:</strong> {profile.designation}
          </p>
          <p>
            <strong>Category:</strong> {profile.category}
          </p>
          <p>
            <strong>Deployment Area:</strong> {profile.deploymentArea}
          </p>
          <p>
            <strong>Responsibility:</strong> {profile.responsibility}
          </p>
          <p>
            <strong>Reporting To:</strong> {profile.reportingTo}
          </p>
          <p>
            <strong>SpeakUp Reporting:</strong> {profile.speakUpReporting}
          </p>
          <p>
            <strong>MDLZ SPOC:</strong> {profile.mdlzSpoc}
          </p>
          <p>
            <strong>Contact No:</strong> {profile.contactNo}
          </p>

          <div className="buttons-row">
            <button onClick={handleAddFingerprint} className="submit-btn">
              Add Fingerprint
            </button>
            <button onClick={handleCancel} className="cancel-btn">
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* STEP 3 */}
      {step === "touchFinger" && (
        <div className="fingerprint-box">
          <h2>Scan Employee Fingerprint</h2>
          <p className="scan-message">{scanMessage}</p>

          <div className="scanner-container">
            <img
              src={verificationImg}
              alt="scanner"
              className="fingerprint-img"
            />
            {processing && <div className="scan-indicator scanning"></div>}
          </div>

          <p className="timeout-note">⏱ Auto-cancel after 10 seconds</p>
        </div>
      )}

      {/* STEP 4 */}
      {step === "result" && (
        <div className="result-box">
          <h2>✅ Fingerprint Captured Successfully!</h2>
          <button onClick={() => navigate("/")} className="submit-btn">
            Back to Home
          </button>
        </div>
      )}
    </div>
  );
};

export default AddFingerprint;
